const setNebraskaEndpoint = ENDPOINT_NEBRASKA => ({ ENDPOINT_NEBRASKA });
const discoveryGateway = GATEWAY => ({ GATEWAY });
const discoveryAccountApi = ACCOUNTS => ({ ACCOUNTS });
const discoverySearcherApi = SEARCHER => ({ SEARCHER });
const discoverySeoSebaApi = SEOSEBA => ({ SEOSEBA });
const discoveryThorondorApi = THORONDOR => ({ THORONDOR });
const discoveryCodziennyCzarek = CODZIENNY_CZAREK => ({ CODZIENNY_CZAREK });
const discoveryCalifornia = CALIFORNIA => ({ CALIFORNIA });
const discoveryFirmowyFilip = FIRMOWY_FILIP => ({ FIRMOWY_FILIP });
const discoveryApiOffers = OFFERS => ({ OFFERS });
const discoveryRecommendationsApi = RECOMMENDATIONS => ({ RECOMMENDATIONS });

module.exports = ({
  ENDPOINT_NEBRASKA,
  API_CONSUL_ACCOUNTS,
  API_CONSUL_GATEWAY,
  API_CONSUL_SEARCHER,
  API_CONSUL_SEOSEBA,
  API_CONSUL_THORONDOR,
  API_CONSUL_CODZIENNY_CZAREK,
  API_CONSUL_CALIFORNIA,
  API_CONSUL_FIRMOWY_FILIP,
  API_CONSUL_OFFERS,
  API_CONSUL_RECOMMENDATIONS
}) => ({
  ...setNebraskaEndpoint(ENDPOINT_NEBRASKA),
  ...discoveryGateway(API_CONSUL_GATEWAY),
  ...discoveryAccountApi(API_CONSUL_ACCOUNTS),
  ...discoverySearcherApi(API_CONSUL_SEARCHER),
  ...discoverySeoSebaApi(API_CONSUL_SEOSEBA),
  ...discoveryThorondorApi(API_CONSUL_THORONDOR),
  ...discoveryCodziennyCzarek(API_CONSUL_CODZIENNY_CZAREK),
  ...discoveryCalifornia(API_CONSUL_CALIFORNIA),
  ...discoveryFirmowyFilip(API_CONSUL_FIRMOWY_FILIP),
  ...discoveryApiOffers(API_CONSUL_OFFERS),
  ...discoveryRecommendationsApi(API_CONSUL_RECOMMENDATIONS)
});
